import React from 'react'
export default (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="4"
      y="3"
      width="16"
      height="18"
      rx="2"
      ry="2"
      stroke="#666"
      strokeWidth="1.5"
    />
    <path d="M8 7H16" stroke="#666" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M8 11H16" stroke="#666" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M8 15H12" stroke="#666" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="16.5" cy="16.5" r="1.5" stroke="#666" strokeWidth="1.5" />
  </svg>
)
